export default [
    {
      path: '/portfolios',
      name: 'portfolios-read',
      component: () => import('@/views/portfolios/blog-list/BlogList.vue'),
      meta: {
        resource: 'Portfolios',
        action: 'read',
      },
    },
    {
        path: '/portfolios/create',
        name: 'portfolios-create',
        component: () => import('@/views/portfolios/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Portfolios',
          action: 'create',
        },
    },
    {
      path: '/portfolios-category',
      name: 'portfolios-category-read',
      component: () => import('@/views/portfolios/category-list/CategoryList.vue'),
      meta: {
        resource: 'Portfolio Categories',
        action: 'read',
      },
    },
    {
        path: '/portfolios-category/create',
        name: 'portfolios-category-create',
        component: () => import('@/views/portfolios/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Portfolio Categories',
          action: 'create',
        },
    },
    
    
  ]
  